import React, { useState, useEffect } from 'react'
import useApi from '../../../../utils/api-manager/Helper/useApi'
import loader from '../../../../assets/Image/Loader2.gif'
import { useShift } from './ShiftContext'
import './DailyLottery.css'

const DailyLottery = () => {
  const { Post, Get } = useApi()

  const [lotteryData, setLotteryData] = useState({
    onlineNetSales: '',
    onlineCashing: '',
    instantCashing: '',
    onlineNetSalesYesterday: '',
    onlineCashingYesterday: '',
    instantCashingYesterday: '',
    totalNetSalesSR50: '',
    totalOnlineCashingSR50: '',
    totalInstantCashingToday: '',
    instantSaleSR34: '',
    creditSales: '',
    debitSales: '',
    registerCash: '',
    overShort: '',
    previousDayOnlineNetSales: '',
    previousDayOnlineCashing: '',
    previousDayInstantCashing: ''
  })

  const [lotteryReportId, setLotteryReportId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showShiftDialog, setShowShiftDialog] = useState(false)
  const [selectedDate, setSelectedDate] = useState()
  const [selectedTime, setSelectedTime] = useState(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }))
  const [errorMessage, setErrorMessage] = useState('')
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  
  const { shiftData, startShift, endShift } = useShift()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setLotteryData(prev => ({ ...prev, [name]: value }))
  }

  const handleInputBlur = async (e) => {
    const { name, value } = e.target

    if (!lotteryReportId) return

    const fieldMapping = {
      onlineNetSales: { key: 'net_sales_sr50', hasRegister: true },
      onlineCashing: { key: 'online_cashing_sr50', hasRegister: true },
      instantCashing: { key: 'instant_cashing_sr34', hasRegister: true },
      onlineNetSalesYesterday: { key: 'net_sales_sr51', hasRegister: true },
      onlineCashingYesterday: { key: 'online_cashing_sr51', hasRegister: true },
      instantCashingYesterday: { key: 'instant_cashing_sr35', hasRegister: true },
      registerCash: { key: 'register_cash', hasRegister: true },
      overShort: { key: 'over_short', hasRegister: true },
      totalNetSalesSR50: { key: 'total_net_sales_sr50', hasRegister: false },
      totalOnlineCashingSR50: { key: 'total_online_cashing_sr50', hasRegister: false },
      totalInstantCashingToday: { key: 'total_instant_cashing_today', hasRegister: false },
      instantSaleSR34: { key: 'instant_sale_sr34', hasRegister: false },
      creditSales: { key: 'credit_sales', hasRegister: false },
      debitSales: { key: 'debit_sales', hasRegister: false }
    }

    const mapping = fieldMapping[name]
    if (mapping) {
      try {
        setLoading(true)
        const payload = {
          lottery_report: lotteryReportId,
          [mapping.key]: parseFloat(value) || 0.0
        }

        if (mapping.hasRegister) {
          payload.register_no = "1"
        }

        await Post("updateLotteryReport", payload)
        fetchShiftData();
      } catch (error) {
        console.error('Error updating field:', error)
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchLotteryReportId()
    fetchShiftData()
  }, [])

  const fetchLotteryReportId = async () => {
    try {
      const response = await Get('isShiftActive')
      if (response && response.message && (response.message.includes('No active shift') || response.message.includes('No shifts available'))) {
        setShowShiftDialog(true)
        return
      }
      if (response && response.lotteryReport) {
        setLotteryReportId(response.lotteryReport)
      }
    } catch (error) {
      console.error('Error fetching lottery report ID:', error)
    }
  }

  const fetchShiftData = async () => {
    try {
      const today = new Date().toISOString().split('T')[0]
      const response = await Post('getShiftDataWithRole', { date: today });

      if (response && response.data.shift_data && response.data.shift_data.length > 0) {
        const activeShift = response.data.shift_data.find(shift => shift.shift.is_active) || response.data.shift_data[0]
        if (activeShift && activeShift.lottery_report && activeShift.lottery_register_reports.length > 0) {
          const lotteryReport = activeShift.lottery_report
          const registerReport = activeShift.lottery_register_reports[0]
          setLotteryData({
            onlineNetSales: registerReport.net_sales_sr50 || '',
            onlineCashing: registerReport.online_cashing_sr50 || '',
            instantCashing: registerReport.instant_cashing_sr34 || '',
            onlineNetSalesYesterday: registerReport.net_sales_sr51 || '',
            onlineCashingYesterday: registerReport.online_cashing_sr51 || '',
            instantCashingYesterday: registerReport.instant_cashing_sr35 || '',
            totalNetSalesSR50: lotteryReport.total_net_sales_sr50 || '',
            totalOnlineCashingSR50: lotteryReport.total_online_cashing_sr50 || '',
            totalInstantCashingToday: lotteryReport.total_instant_cashing_today || '',
            totalNetSalesSR51: lotteryReport.total_net_sales_sr51 || '',
            totalOnlineCashingSR51: lotteryReport.total_online_cashing_sr51 || '',
            totalInstantCashingYesterday: lotteryReport.total_instant_cashing_yesterday || '',
            totalOnlineBalance: lotteryReport.total_online_balance || '',
            instantSaleSR34: lotteryReport.instant_sale_sr34 || '',
            creditSales: lotteryReport.credit_sales || '',
            debitSales: lotteryReport.debit_sales || '',
            registerCash: lotteryReport.register_cash || '',
            overShort: lotteryReport.over_short || '',
            previousDayOnlineNetSales: '',
            previousDayOnlineCashing: '',
            previousDayInstantCashing: ''
          })
        }
      }
    } catch (error) {
      console.error('Error fetching shift data:', error)
    }
  }



  return (
    <div className="responsive-box daily-lottery-page">
      {loading && (
        <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
          <img src={loader} alt="Loading..." style={{ width: '50px', height: '50px' }} />
        </div>
      )}
      
      {showShiftDialog ? (
        <div className="shift-selection-wrapper">
          <div className="shift-form-container">
            {errorMessage && <div className="alert alert-danger" style={{ marginBottom: '20px' }}>{errorMessage}</div>}
            <div className="info-tag" style={{
              backgroundColor: "#e3fde7ff",
              border: "1px solid #282e26",
              borderRadius: "8px",
              padding: "12px 16px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#282e26",
              fontSize: "14px",
              fontWeight: "500"
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
              </svg>
              Please select today's date to start your shift with lottery
            </div>
            
            <div className="form-group">
              <label htmlFor="dateInput" className="form-label">Select Shift Date:</label>
              <input
                id="dateInput"
                type="date"
                className="form-control-borderless"
                value={selectedDate || ''}
                onChange={async (e) => {
                  setSelectedDate(e.target.value)
                  setLoading(true)
                  const result = await startShift(e.target.value, selectedTime)
                  if (result.success) {
                    setShowShiftDialog(false)
                    await fetchLotteryReportId()
                    await fetchShiftData()
                  } else {
                    setErrorMessage('Failed to start shift. Please try again.')
                  }
                  setLoading(false)
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="timeInput" className="form-label">Select Time:</label>
              <input
                id="timeInput"
                type="time"
                className="form-control-borderless"
                value={selectedTime.slice(0, 5)}
                onChange={(e) => setSelectedTime(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="shiftSelect" className="form-label">Select Shift:</label>
              <select
                id="shiftSelect"
                className="form-control"
                value={shiftData.title || 'Shift 2'}
                readOnly
              >
                <option value={shiftData.title || 'Shift 2'}>{shiftData.title || 'Shift 2'}</option>
              </select>
            </div>
          </div>
        </div>
      ) : (
        <>
          {showConfirmModal && <div className="modal-backdrop fade show"></div>}
          <div className={`modal ${showConfirmModal ? 'show' : ''}`} style={{ display: showConfirmModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-hidden={!showConfirmModal}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Shift</h5>
                </div>
                <div className="modal-body">
                  {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                  Do you want to start{' '}
                  <span className="shift-badge">
                    {shiftData.title || 'Shift 1'}
                  </span>
                  {' '}on {selectedDate ? new Date(selectedDate).toLocaleDateString() : ''} at {selectedTime}?
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-contained" onClick={() => setShowConfirmModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={async () => {
                    setLoading(true)
                    const result = await startShift(selectedDate, selectedTime)
                    if (result.success) {
                      setShowShiftDialog(false)
                      setShowConfirmModal(false)
                      await fetchLotteryReportId()
                      await fetchShiftData()
                    } else {
                      setErrorMessage('Failed to start shift. Please try again.')
                    }
                    setLoading(false)
                  }}>Confirm</button>
                </div>
              </div>
            </div>
          </div>
        <>
          <div className="daily-lottery-header">
            <div>
              <span className="daily-lottery-eyebrow">Shift report</span>
              <h2 className="mb-0">Daily Lottery Report</h2>
              <p className="daily-lottery-subtitle">Review lottery invoice totals, cash movement and over/short before ending the shift.</p>
            </div>
            <button 
              type="button" 
              className="btn btn-danger daily-lottery-end-shift"
              onClick={async () => {
                setLoading(true)
                const result = await endShift()
                if (result.success) {
                  setShowShiftDialog(true)
                } else {
                  setErrorMessage('Failed to end shift. Please try again.')
                }
                setLoading(false)
              }}
            >
              End Shift
            </button>
          </div>

      <div className="daily-lottery-report-grid">
        <div className="col-md-4 daily-lottery-section" style={{ paddingRight: '15px' }}>
          <div className="business-title-header">
            <p className="business-report-title">Today Invoice</p>
          </div>
          <div className="business-report">
            <div className="data-report">
              <label className="label">Online Net Sales </label>
              <input
                type="text"
                className="input"
                name="onlineNetSales"
                value={lotteryData.onlineNetSales}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Online Cashing </label>
              <input
                type="text"
                className="input"
                name="onlineCashing"
                value={lotteryData.onlineCashing}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Instant Cashing</label>
              <input
                type="text"
                className="input"
                name="instantCashing"
                value={lotteryData.instantCashing}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Total Net Sales</label>
              <input
                type="text"
                className="input-readonly"
                name="totalNetSalesSR50"
                value={lotteryData.totalNetSalesSR50}
                readOnly
              />
            </div>

            <div className="data-report">
              <label className="label">Total Online Cashing</label>
              <input
                type="text"
                className="input-readonly"
                name="totalOnlineCashingSR50"
                value={lotteryData.totalOnlineCashingSR50}
                readOnly
              />
            </div>

            <div className="data-report">
              <label className="label">Total Instant Cashing</label>
              <input
                type="text"
                className="input-readonly"
                name="totalInstantCashingToday"
                value={lotteryData.totalInstantCashingToday}
                readOnly
              />
            </div>

            <div className="data-report">
              <label className="label">Instant Sale SR34</label>
              <input
                type="text"
                className="input"
                name="instantSaleSR34"
                value={lotteryData.instantSaleSR34}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>
          </div>
        </div>

        <div className="col-md-4 daily-lottery-section" style={{ padding: '0 15px' }}>
          <div className="business-title-header">
            <p className="business-report-title">Yesterday Invoice</p>
          </div>
          <div className="business-report">
            <div className="data-report">
              <label className="label">Online Net Sales</label>
              <input
                type="text"
                className="input"
                name="onlineNetSalesYesterday"
                value={lotteryData.onlineNetSalesYesterday}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Online Cashing</label>
              <input
                type="text"
                className="input"
                name="onlineCashingYesterday"
                value={lotteryData.onlineCashingYesterday}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Instant Cashing</label>
              <input
                type="text"
                className="input"
                name="instantCashingYesterday"
                value={lotteryData.instantCashingYesterday}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Total Net Sales</label>
              <input
                type="text"
                className="input-readonly"
                value={lotteryData.totalNetSalesSR51 || ''}
                readOnly
              />
            </div>

            <div className="data-report">
              <label className="label">Total Online Cashing</label>
              <input
                type="text"
                className="input-readonly"
                value={lotteryData.totalOnlineCashingSR51 || ''}
                readOnly
              />
            </div>

            <div className="data-report">
              <label className="label">Total Instant Cashing</label>
              <input
                type="text"
                className="input-readonly"
                value={lotteryData.totalInstantCashingYesterday || ''}
                readOnly
              />
            </div>
          </div>
        </div>


        <div className="col-md-4 daily-lottery-section">
          <div className="business-title-header">
            <p className="business-report-title">Today Cash</p>
          </div>
          <div className="business-report">
            <div className="data-report">
              <label className="label">Total Online Balance</label>
              <input
                type="text"
                className="input-readonly"
                value={lotteryData.totalOnlineBalance || ''}
                readOnly
              />
            </div>

            <div className="data-report">
              <label className="label">Credit Sales</label>
              <input
                type="text"
                className="input"
                name="creditSales"
                value={lotteryData.creditSales}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Debit Sales</label>
              <input
                type="text"
                className="input"
                name="debitSales"
                value={lotteryData.debitSales}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Register Cash</label>
              <input
                type="text"
                className="input"
                name="registerCash"
                value={lotteryData.registerCash}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>

            <div className="data-report">
              <label className="label">Over Short</label>
              <input
                type="text"
                className="input"
                name="overShort"
                value={lotteryData.overShort}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={(e) => e.target.select()}
              />
            </div>
          </div>
        </div>
      </div>
        </>
        </>
      )}
      
    </div>
  )
}

export default DailyLottery
